<template>
  <ul v-if="itemData" class="data-list">
    <li :key="key" v-for="(value, key) in itemData">
      <span class="elr-bold">{{title(key)}}: </span> 
      <span v-if="!Array.isArray(value)">{{value}}</span>
      <WordList v-if="Array.isArray(value)" :values="value" />
    </li>
  </ul>
  <ul v-else class="data-list">
    <li>No data</li>
  </ul>
</template>

<script>
import { title } from '../../utils/helpers';
import WordList from '../WordList/WordList';

export default {
  name: 'DataList',
  props: {
    item: {
      type: Object,
      required: true
    },
    fields: {
      type: Array,
      default: () => []
    }
  },
  components: {
    WordList
  },
  computed: {
    itemData() {
      if (this.fields && this.fields.length) {
        const filtered = this.fields.map(o => ({[o]: this.item[o]}));

        return Object.assign({}, ...filtered);
      }

      return null;
    }
  },
  methods: {
    title
  }
}
</script>

<style lang="scss" scoped>

.data-list {
  padding: 0;
  margin-left: 0;
  margin-bottom: 40px;
}

.data-list li {
  list-style: none;
}

</style>


